import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 minutos en segundos
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <motion.div initial={{
    scale: 0.9,
    opacity: 0
  }} animate={{
    scale: 1,
    opacity: 1
  }} className="inline-flex items-center gap-2 md:gap-3 bg-red-500 text-white px-4 md:px-6 py-2 md:py-3 rounded-full font-bold shadow-lg" data-id="element-9">
      <Clock className="w-4 h-4 md:w-5 md:h-5 animate-pulse" data-id="element-10" />
      <span className="text-base md:text-lg tracking-wider" data-id="element-11">
        {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
      </span>
    </motion.div>;
}